
import { defineComponent } from "vue";

export default defineComponent({
    name: "TogglePlayButton",
    props: {
        isPlaying: Boolean
    }
});
